// FAQ content translations for all languages
export const getFAQContent = (t, language) => {
  const faqData = {
    en: {
      gettingStarted: [
        {
          q: "What does MockupPro do?",
          a: "MockupPro combines 5+ AI tools into one platform: generate prompts from images, enhance prompts, create AI images, design product mockups, and generate backgrounds—all in one seamless workflow."
        },
        {
          q: "Is this better than using multiple tools?",
          a: "Yes. Instead of switching between 4-5 different apps, everything connects in one place. Upload → Generate prompt → Create image → Make mockup. No exports, no re-uploads."
        },
        {
          q: "What types of images can I upload?",
          a: "PNG, JPG, and WEBP formats. For mockups, transparent PNGs work best. Maximum file size: 10MB."
        },
        {
          q: "Do I need design experience?",
          a: "No. Just upload or describe what you want. The AI handles the rest."
        }
      ],
      billing: [
        {
          q: "How much does MockupPro cost?",
          a: "Three plans: Starter ($15/mo, 100 credits), Growth ($29/mo, 500 credits), Pro ($49/mo, 2000 credits). Start with a free trial."
        },
        {
          q: "Is there a free trial?",
          a: "Yes! Start with 120 free credits. During your trial, you get reduced credit costs: prompts cost just 1 credit, mockups cost 2 credits. No credit card required. Credits are designed for exploration—test multiple prompts and mockups to find what works best for you."
        },
        {
          q: "Can I change my plan anytime?",
          a: "Yes. Upgrade or downgrade from Settings → Billing. Changes take effect immediately."
        },
        {
          q: "What payment methods do you accept?",
          a: "All major credit/debit cards via Stripe. Secure and encrypted."
        }
      ],
      credits: [
        {
          q: "How do credits work?",
          a: "Every AI action uses credits. Trial users get reduced costs: Prompt generation (1 credit), Mockup generation (2 credits), Background generation (2 credits). Paid plans have standard rates. You will always see how many credits an action uses before generating."
        },
        {
          q: "What happens when I run out of credits?",
          a: "You can't generate until you get more. Upgrade your plan for more monthly credits, or wait for your next billing cycle."
        },
        {
          q: "Do unused credits roll over?",
          a: "No. Credits reset each billing cycle. Use them or lose them."
        },
        {
          q: "Can I buy extra credits?",
          a: "Currently, upgrading your plan is the best way to get more credits. One-time credit packs coming soon."
        }
      ],
      features: [
        {
          q: "What kind of mockups can I create?",
          a: "Lifestyle scenes, hand-held product shots, desk setups, outdoor scenes, and studio shots. All look like real photography."
        },
        {
          q: "What styles can I generate images in?",
          a: "Product photography, sticker style, illustrations, and photorealistic. Each optimized for different use cases."
        },
        {
          q: "Can I edit the generated prompts?",
          a: "Yes. All prompts are editable before you generate. Tweak as needed."
        },
        {
          q: "What's the Workflow feature?",
          a: "A connected creative pipeline: Upload image → Generate prompt (1 credit) → Enhance prompt (1 credit) → Generate mockup (2 credits) → Download. Everything flows together seamlessly."
        },
        {
          q: "Can I share my creations?",
          a: "Yes. Share to Twitter, Facebook, Pinterest, LinkedIn, or copy a public link. Track views and clicks in Share Analytics."
        }
      ],
      account: [
        {
          q: "Can I cancel anytime?",
          a: "Yes. Cancel instantly from Settings → Billing. No questions, no hidden fees, no friction."
        },
        {
          q: "Do I lose access after canceling?",
          a: "Yes. Access ends immediately upon cancellation. Download your creations from Gallery first."
        },
        {
          q: "How do I delete my account?",
          a: "Contact support at contact@mockuppro.org. We'll process your request within 48 hours."
        },
        {
          q: "Is my data secure?",
          a: "Yes. All data is encrypted. We don't sell or share your information. Images are stored securely."
        }
      ]
    },
    es: {
      gettingStarted: [
        {
          q: "¿Qué hace MockupPro?",
          a: "MockupPro combina más de 5 herramientas de IA en una plataforma: genera prompts desde imágenes, mejora prompts, crea imágenes con IA, diseña mockups de productos y genera fondos—todo en un flujo de trabajo fluido."
        },
        {
          q: "¿Es mejor que usar múltiples herramientas?",
          a: "Sí. En lugar de cambiar entre 4-5 aplicaciones diferentes, todo se conecta en un solo lugar. Sube → Genera prompt → Crea imagen → Haz mockup. Sin exportaciones, sin resubidas."
        },
        {
          q: "¿Qué tipos de imágenes puedo subir?",
          a: "Formatos PNG, JPG y WEBP. Para mockups, los PNG transparentes funcionan mejor. Tamaño máximo: 10MB."
        },
        {
          q: "¿Necesito experiencia en diseño?",
          a: "No. Solo sube o describe lo que quieres. La IA se encarga del resto."
        }
      ],
      billing: [
        {
          q: "¿Cuánto cuesta MockupPro?",
          a: "Tres planes: Starter ($15/mes, 100 créditos), Growth ($29/mes, 500 créditos), Pro ($49/mes, 2000 créditos). Comienza con una prueba gratis."
        },
        {
          q: "¿Hay una prueba gratuita?",
          a: "¡Sí! Comienza con 120 créditos gratis. Durante tu prueba, obtienes costos reducidos: los prompts cuestan solo 1 crédito, los mockups cuestan 2 créditos. No se requiere tarjeta de crédito. Los créditos están diseñados para exploración—prueba múltiples prompts y mockups para encontrar lo que funciona mejor."
        },
        {
          q: "¿Puedo cambiar mi plan en cualquier momento?",
          a: "Sí. Mejora o reduce desde Configuración → Facturación. Los cambios se aplican inmediatamente."
        },
        {
          q: "¿Qué métodos de pago aceptan?",
          a: "Todas las tarjetas de crédito/débito principales a través de Stripe. Seguro y encriptado."
        }
      ],
      credits: [
        {
          q: "¿Cómo funcionan los créditos?",
          a: "Cada acción de IA usa créditos. Los usuarios de prueba obtienen costos reducidos: Generación de prompt (1 crédito), Generación de mockup (2 créditos), Generación de fondo (2 créditos). Siempre verás cuántos créditos usa una acción antes de generar."
        },
        {
          q: "¿Qué pasa cuando me quedo sin créditos?",
          a: "No puedes generar hasta que obtengas más. Mejora tu plan para más créditos mensuales, o espera tu próximo ciclo de facturación."
        },
        {
          q: "¿Los créditos no usados se acumulan?",
          a: "No. Los créditos se reinician cada ciclo de facturación. Úsalos o piérdelos."
        },
        {
          q: "¿Puedo comprar créditos extra?",
          a: "Actualmente, mejorar tu plan es la mejor forma de obtener más créditos. Paquetes de créditos únicos próximamente."
        }
      ],
      features: [
        {
          q: "¿Qué tipo de mockups puedo crear?",
          a: "Escenas lifestyle, fotos de productos en mano, configuraciones de escritorio, escenas al aire libre y tomas de estudio. Todos parecen fotografía real."
        },
        {
          q: "¿En qué estilos puedo generar imágenes?",
          a: "Fotografía de producto, estilo sticker, ilustraciones y fotorrealista. Cada uno optimizado para diferentes casos de uso."
        },
        {
          q: "¿Puedo editar los prompts generados?",
          a: "Sí. Todos los prompts son editables antes de generar. Ajusta según necesites."
        },
        {
          q: "¿Qué es la función Workflow?",
          a: "Un pipeline conectado de 5 pasos: Subir → Extraer prompts → Mejorar → Generar imagen → Crear mockup. Todo fluye junto."
        },
        {
          q: "¿Puedo compartir mis creaciones?",
          a: "Sí. Comparte en Twitter, Facebook, Pinterest, LinkedIn, o copia un enlace público. Rastrea vistas y clics en Analíticas de Compartir."
        }
      ],
      account: [
        {
          q: "¿Puedo cancelar en cualquier momento?",
          a: "Sí. Cancela instantáneamente desde Configuración → Facturación. Sin preguntas, sin cargos ocultos, sin fricción."
        },
        {
          q: "¿Pierdo acceso después de cancelar?",
          a: "Sí. El acceso termina inmediatamente al cancelar. Descarga tus creaciones de la Galería primero."
        },
        {
          q: "¿Cómo elimino mi cuenta?",
          a: "Contacta soporte en contact@mockuppro.org. Procesaremos tu solicitud en 48 horas."
        },
        {
          q: "¿Mis datos están seguros?",
          a: "Sí. Todos los datos están encriptados. No vendemos ni compartimos tu información. Las imágenes se almacenan de forma segura."
        }
      ]
    },
    fr: {
      gettingStarted: [
        {
          q: "Que fait MockupPro ?",
          a: "MockupPro combine plus de 5 outils IA en une seule plateforme : générez des prompts à partir d'images, améliorez les prompts, créez des images IA, concevez des mockups de produits et générez des arrière-plans—tout dans un flux de travail fluide."
        },
        {
          q: "C'est mieux que d'utiliser plusieurs outils ?",
          a: "Oui. Au lieu de basculer entre 4-5 applications différentes, tout se connecte en un seul endroit. Téléchargez → Générez un prompt → Créez une image → Faites un mockup. Pas d'exports, pas de re-téléchargements."
        },
        {
          q: "Quels types d'images puis-je télécharger ?",
          a: "Formats PNG, JPG et WEBP. Pour les mockups, les PNG transparents fonctionnent le mieux. Taille maximale : 10 Mo."
        },
        {
          q: "Ai-je besoin d'expérience en design ?",
          a: "Non. Téléchargez ou décrivez simplement ce que vous voulez. L'IA s'occupe du reste."
        }
      ],
      billing: [
        {
          q: "Combien coûte MockupPro ?",
          a: "Trois plans : Starter (15$/mois, 100 crédits), Growth (29$/mois, 500 crédits), Pro (49$/mois, 2000 crédits). Commencez avec un essai gratuit."
        },
        {
          q: "Y a-t-il un essai gratuit ?",
          a: "Oui ! Commencez avec 120 crédits gratuits. Pendant votre essai, vous bénéficiez de coûts réduits : les prompts ne coûtent qu'1 crédit, les mockups 2 crédits. Pas de carte de crédit requise. Les crédits sont conçus pour l'exploration—testez plusieurs prompts et mockups pour trouver ce qui fonctionne le mieux."
        },
        {
          q: "Puis-je changer de plan à tout moment ?",
          a: "Oui. Passez à un plan supérieur ou inférieur depuis Paramètres → Facturation. Les changements prennent effet immédiatement."
        },
        {
          q: "Quels modes de paiement acceptez-vous ?",
          a: "Toutes les principales cartes de crédit/débit via Stripe. Sécurisé et crypté."
        }
      ],
      credits: [
        {
          q: "Comment fonctionnent les crédits ?",
          a: "Chaque action IA utilise des crédits. Les utilisateurs d'essai bénéficient de coûts réduits : Génération de prompt (1 crédit), Génération de mockup (2 crédits), Génération d'arrière-plan (2 crédits). Vous verrez toujours combien de crédits une action utilise avant de générer."
        },
        {
          q: "Que se passe-t-il quand je n'ai plus de crédits ?",
          a: "Vous ne pouvez pas générer tant que vous n'en avez pas plus. Passez à un plan supérieur pour plus de crédits mensuels, ou attendez votre prochain cycle de facturation."
        },
        {
          q: "Les crédits non utilisés sont-ils reportés ?",
          a: "Non. Les crédits sont réinitialisés à chaque cycle de facturation. Utilisez-les ou perdez-les."
        },
        {
          q: "Puis-je acheter des crédits supplémentaires ?",
          a: "Actuellement, passer à un plan supérieur est le meilleur moyen d'obtenir plus de crédits. Packs de crédits ponctuels bientôt disponibles."
        }
      ],
      features: [
        {
          q: "Quels types de mockups puis-je créer ?",
          a: "Scènes lifestyle, photos de produits en main, configurations de bureau, scènes en extérieur et photos studio. Tous ressemblent à de vraies photos."
        },
        {
          q: "Dans quels styles puis-je générer des images ?",
          a: "Photographie de produit, style autocollant, illustrations et photoréaliste. Chacun optimisé pour différents cas d'utilisation."
        },
        {
          q: "Puis-je modifier les prompts générés ?",
          a: "Oui. Tous les prompts sont modifiables avant de générer. Ajustez selon vos besoins."
        },
        {
          q: "Qu'est-ce que la fonction Workflow ?",
          a: "Un pipeline connecté en 5 étapes : Télécharger → Extraire les prompts → Améliorer → Générer l'image → Créer le mockup. Tout s'enchaîne."
        },
        {
          q: "Puis-je partager mes créations ?",
          a: "Oui. Partagez sur Twitter, Facebook, Pinterest, LinkedIn, ou copiez un lien public. Suivez les vues et clics dans les Analyses de Partage."
        }
      ],
      account: [
        {
          q: "Puis-je annuler à tout moment ?",
          a: "Oui. Annulez instantanément depuis Paramètres → Facturation. Pas de questions, pas de frais cachés, pas de friction."
        },
        {
          q: "Est-ce que je perds l'accès après l'annulation ?",
          a: "Oui. L'accès se termine immédiatement après l'annulation. Téléchargez d'abord vos créations depuis la Galerie."
        },
        {
          q: "Comment supprimer mon compte ?",
          a: "Contactez le support à contact@mockuppro.org. Nous traiterons votre demande sous 48 heures."
        },
        {
          q: "Mes données sont-elles sécurisées ?",
          a: "Oui. Toutes les données sont cryptées. Nous ne vendons ni ne partageons vos informations. Les images sont stockées en toute sécurité."
        }
      ]
    },
    de: {
      gettingStarted: [
        {
          q: "Was macht MockupPro?",
          a: "MockupPro kombiniert über 5 KI-Tools in einer Plattform: Generieren Sie Prompts aus Bildern, verbessern Sie Prompts, erstellen Sie KI-Bilder, designen Sie Produkt-Mockups und generieren Sie Hintergründe—alles in einem nahtlosen Workflow."
        },
        {
          q: "Ist das besser als mehrere Tools zu verwenden?",
          a: "Ja. Anstatt zwischen 4-5 verschiedenen Apps zu wechseln, ist alles an einem Ort verbunden. Hochladen → Prompt generieren → Bild erstellen → Mockup machen. Keine Exporte, keine erneuten Uploads."
        },
        {
          q: "Welche Bildtypen kann ich hochladen?",
          a: "PNG-, JPG- und WEBP-Formate. Für Mockups funktionieren transparente PNGs am besten. Maximale Dateigröße: 10 MB."
        },
        {
          q: "Brauche ich Designerfahrung?",
          a: "Nein. Laden Sie einfach hoch oder beschreiben Sie, was Sie wollen. Die KI erledigt den Rest."
        }
      ],
      billing: [
        {
          q: "Wie viel kostet MockupPro?",
          a: "Drei Pläne: Starter (15$/Monat, 100 Credits), Growth (29$/Monat, 500 Credits), Pro (49$/Monat, 2000 Credits). Starten Sie mit einer kostenlosen Testversion."
        },
        {
          q: "Gibt es eine kostenlose Testversion?",
          a: "Ja! Starten Sie mit 120 kostenlosen Credits. Während Ihrer Testphase erhalten Sie reduzierte Kosten: Prompts kosten nur 1 Credit, Mockups 2 Credits. Keine Kreditkarte erforderlich. Credits sind für die Erkundung konzipiert—testen Sie mehrere Prompts und Mockups, um zu finden, was am besten funktioniert."
        },
        {
          q: "Kann ich meinen Plan jederzeit ändern?",
          a: "Ja. Upgraden oder downgraden Sie unter Einstellungen → Abrechnung. Änderungen werden sofort wirksam."
        },
        {
          q: "Welche Zahlungsmethoden akzeptieren Sie?",
          a: "Alle gängigen Kredit-/Debitkarten über Stripe. Sicher und verschlüsselt."
        }
      ],
      credits: [
        {
          q: "Wie funktionieren Credits?",
          a: "Jede KI-Aktion verbraucht Credits. Testnutzer erhalten reduzierte Kosten: Prompt-Generierung (1 Credit), Mockup-Generierung (2 Credits), Hintergrund-Generierung (2 Credits). Sie sehen immer, wie viele Credits eine Aktion vor dem Generieren verbraucht."
        },
        {
          q: "Was passiert, wenn mir die Credits ausgehen?",
          a: "Sie können nicht generieren, bis Sie mehr haben. Upgraden Sie Ihren Plan für mehr monatliche Credits oder warten Sie auf Ihren nächsten Abrechnungszyklus."
        },
        {
          q: "Werden nicht verwendete Credits übertragen?",
          a: "Nein. Credits werden jeden Abrechnungszyklus zurückgesetzt. Nutzen Sie sie oder verlieren Sie sie."
        },
        {
          q: "Kann ich zusätzliche Credits kaufen?",
          a: "Derzeit ist das Upgraden Ihres Plans der beste Weg, mehr Credits zu erhalten. Einmalige Credit-Pakete kommen bald."
        }
      ],
      features: [
        {
          q: "Welche Art von Mockups kann ich erstellen?",
          a: "Lifestyle-Szenen, Produktfotos in der Hand, Schreibtisch-Setups, Outdoor-Szenen und Studio-Aufnahmen. Alle sehen aus wie echte Fotografie."
        },
        {
          q: "In welchen Stilen kann ich Bilder generieren?",
          a: "Produktfotografie, Aufkleber-Stil, Illustrationen und fotorealistisch. Jeder ist für verschiedene Anwendungsfälle optimiert."
        },
        {
          q: "Kann ich die generierten Prompts bearbeiten?",
          a: "Ja. Alle Prompts sind vor dem Generieren bearbeitbar. Passen Sie nach Bedarf an."
        },
        {
          q: "Was ist die Workflow-Funktion?",
          a: "Eine verbundene 5-Schritte-Pipeline: Hochladen → Prompts extrahieren → Verbessern → Bild generieren → Mockup erstellen. Alles fließt zusammen."
        },
        {
          q: "Kann ich meine Kreationen teilen?",
          a: "Ja. Teilen Sie auf Twitter, Facebook, Pinterest, LinkedIn oder kopieren Sie einen öffentlichen Link. Verfolgen Sie Aufrufe und Klicks in der Share-Analyse."
        }
      ],
      account: [
        {
          q: "Kann ich jederzeit kündigen?",
          a: "Ja. Kündigen Sie sofort unter Einstellungen → Abrechnung. Keine Fragen, keine versteckten Gebühren, keine Reibung."
        },
        {
          q: "Verliere ich den Zugang nach der Kündigung?",
          a: "Ja. Der Zugang endet sofort nach der Kündigung. Laden Sie zuerst Ihre Kreationen aus der Galerie herunter."
        },
        {
          q: "Wie lösche ich mein Konto?",
          a: "Kontaktieren Sie den Support unter contact@mockuppro.org. Wir werden Ihre Anfrage innerhalb von 48 Stunden bearbeiten."
        },
        {
          q: "Sind meine Daten sicher?",
          a: "Ja. Alle Daten sind verschlüsselt. Wir verkaufen oder teilen Ihre Informationen nicht. Bilder werden sicher gespeichert."
        }
      ]
    },
    pt: {
      gettingStarted: [
        {
          q: "O que o MockupPro faz?",
          a: "MockupPro combina mais de 5 ferramentas de IA em uma plataforma: gere prompts a partir de imagens, aprimore prompts, crie imagens com IA, projete mockups de produtos e gere fundos—tudo em um fluxo de trabalho fluido."
        },
        {
          q: "É melhor do que usar várias ferramentas?",
          a: "Sim. Em vez de alternar entre 4-5 aplicativos diferentes, tudo se conecta em um só lugar. Envie → Gere prompt → Crie imagem → Faça mockup. Sem exportações, sem reenvios."
        },
        {
          q: "Quais tipos de imagens posso enviar?",
          a: "Formatos PNG, JPG e WEBP. Para mockups, PNGs transparentes funcionam melhor. Tamanho máximo: 10MB."
        },
        {
          q: "Preciso de experiência em design?",
          a: "Não. Basta enviar ou descrever o que você quer. A IA cuida do resto."
        }
      ],
      billing: [
        {
          q: "Quanto custa o MockupPro?",
          a: "Três planos: Starter ($15/mês, 100 créditos), Growth ($29/mês, 500 créditos), Pro ($49/mês, 2000 créditos). Comece com um teste grátis."
        },
        {
          q: "Há um teste gratuito?",
          a: "Sim! Comece com 120 créditos grátis. Durante seu teste, você obtém custos reduzidos: prompts custam apenas 1 crédito, mockups custam 2 créditos. Não é necessário cartão de crédito. Os créditos são projetados para exploração—teste múltiplos prompts e mockups para encontrar o que funciona melhor."
        },
        {
          q: "Posso mudar meu plano a qualquer momento?",
          a: "Sim. Faça upgrade ou downgrade em Configurações → Faturamento. As alterações entram em vigor imediatamente."
        },
        {
          q: "Quais métodos de pagamento vocês aceitam?",
          a: "Todos os principais cartões de crédito/débito via Stripe. Seguro e criptografado."
        }
      ],
      credits: [
        {
          q: "Como funcionam os créditos?",
          a: "Cada ação de IA usa créditos. Usuários de teste obtêm custos reduzidos: Geração de prompt (1 crédito), Geração de mockup (2 créditos), Geração de fundo (2 créditos). Você sempre verá quantos créditos uma ação usa antes de gerar."
        },
        {
          q: "O que acontece quando fico sem créditos?",
          a: "Você não pode gerar até ter mais. Faça upgrade do seu plano para mais créditos mensais, ou aguarde seu próximo ciclo de faturamento."
        },
        {
          q: "Créditos não utilizados acumulam?",
          a: "Não. Os créditos são redefinidos a cada ciclo de faturamento. Use-os ou perca-os."
        },
        {
          q: "Posso comprar créditos extras?",
          a: "Atualmente, fazer upgrade do seu plano é a melhor maneira de obter mais créditos. Pacotes de créditos únicos em breve."
        }
      ],
      features: [
        {
          q: "Que tipo de mockups posso criar?",
          a: "Cenas lifestyle, fotos de produtos na mão, configurações de mesa, cenas ao ar livre e fotos de estúdio. Todos parecem fotografia real."
        },
        {
          q: "Em quais estilos posso gerar imagens?",
          a: "Fotografia de produto, estilo adesivo, ilustrações e fotorrealista. Cada um otimizado para diferentes casos de uso."
        },
        {
          q: "Posso editar os prompts gerados?",
          a: "Sim. Todos os prompts são editáveis antes de gerar. Ajuste conforme necessário."
        },
        {
          q: "O que é a função Workflow?",
          a: "Um pipeline conectado de 5 etapas: Enviar → Extrair prompts → Aprimorar → Gerar imagem → Criar mockup. Tudo flui junto."
        },
        {
          q: "Posso compartilhar minhas criações?",
          a: "Sim. Compartilhe no Twitter, Facebook, Pinterest, LinkedIn, ou copie um link público. Acompanhe visualizações e cliques em Análises de Compartilhamento."
        }
      ],
      account: [
        {
          q: "Posso cancelar a qualquer momento?",
          a: "Sim. Cancele instantaneamente em Configurações → Faturamento. Sem perguntas, sem taxas ocultas, sem fricção."
        },
        {
          q: "Perco acesso após cancelar?",
          a: "Sim. O acesso termina imediatamente após o cancelamento. Baixe suas criações da Galeria primeiro."
        },
        {
          q: "Como excluo minha conta?",
          a: "Entre em contato com o suporte em contact@mockuppro.org. Processaremos sua solicitação em 48 horas."
        },
        {
          q: "Meus dados estão seguros?",
          a: "Sim. Todos os dados são criptografados. Não vendemos nem compartilhamos suas informações. As imagens são armazenadas com segurança."
        }
      ]
    },
    it: {
      gettingStarted: [
        {
          q: "Cosa fa MockupPro?",
          a: "MockupPro combina oltre 5 strumenti IA in un'unica piattaforma: genera prompt dalle immagini, migliora i prompt, crea immagini con IA, progetta mockup di prodotti e genera sfondi—tutto in un flusso di lavoro fluido."
        },
        {
          q: "È meglio che usare più strumenti?",
          a: "Sì. Invece di passare tra 4-5 app diverse, tutto si collega in un unico posto. Carica → Genera prompt → Crea immagine → Fai mockup. Niente esportazioni, niente ricaricamenti."
        },
        {
          q: "Quali tipi di immagini posso caricare?",
          a: "Formati PNG, JPG e WEBP. Per i mockup, i PNG trasparenti funzionano meglio. Dimensione massima: 10MB."
        },
        {
          q: "Ho bisogno di esperienza nel design?",
          a: "No. Basta caricare o descrivere cosa vuoi. L'IA fa il resto."
        }
      ],
      billing: [
        {
          q: "Quanto costa MockupPro?",
          a: "Tre piani: Starter ($15/mese, 100 crediti), Growth ($29/mese, 500 crediti), Pro ($49/mese, 2000 crediti). Inizia con una prova gratuita."
        },
        {
          q: "C'è una prova gratuita?",
          a: "Sì! Inizia con 120 crediti gratuiti. Durante la prova, ottieni costi ridotti: i prompt costano solo 1 credito, i mockup 2 crediti. Nessuna carta di credito richiesta. I crediti sono progettati per l'esplorazione—testa più prompt e mockup per trovare cosa funziona meglio."
        },
        {
          q: "Posso cambiare piano in qualsiasi momento?",
          a: "Sì. Fai upgrade o downgrade da Impostazioni → Fatturazione. Le modifiche hanno effetto immediato."
        },
        {
          q: "Quali metodi di pagamento accettate?",
          a: "Tutte le principali carte di credito/debito tramite Stripe. Sicuro e crittografato."
        }
      ],
      credits: [
        {
          q: "Come funzionano i crediti?",
          a: "Ogni azione IA usa crediti. Gli utenti di prova ottengono costi ridotti: Generazione prompt (1 credito), Generazione mockup (2 crediti), Generazione sfondo (2 crediti). Vedrai sempre quanti crediti usa un'azione prima di generare."
        },
        {
          q: "Cosa succede quando finisco i crediti?",
          a: "Non puoi generare finché non ne hai di più. Fai upgrade del tuo piano per più crediti mensili, o aspetta il prossimo ciclo di fatturazione."
        },
        {
          q: "I crediti non utilizzati si accumulano?",
          a: "No. I crediti si azzerano ogni ciclo di fatturazione. Usali o perdili."
        },
        {
          q: "Posso comprare crediti extra?",
          a: "Attualmente, fare upgrade del piano è il modo migliore per ottenere più crediti. Pacchetti di crediti singoli in arrivo."
        }
      ],
      features: [
        {
          q: "Che tipo di mockup posso creare?",
          a: "Scene lifestyle, foto di prodotti in mano, setup da scrivania, scene all'aperto e scatti da studio. Tutti sembrano vera fotografia."
        },
        {
          q: "In quali stili posso generare immagini?",
          a: "Fotografia di prodotto, stile adesivo, illustrazioni e fotorealistico. Ognuno ottimizzato per diversi casi d'uso."
        },
        {
          q: "Posso modificare i prompt generati?",
          a: "Sì. Tutti i prompt sono modificabili prima di generare. Adatta secondo necessità."
        },
        {
          q: "Cos'è la funzione Workflow?",
          a: "Una pipeline connessa in 5 passaggi: Carica → Estrai prompt → Migliora → Genera immagine → Crea mockup. Tutto scorre insieme."
        },
        {
          q: "Posso condividere le mie creazioni?",
          a: "Sì. Condividi su Twitter, Facebook, Pinterest, LinkedIn, o copia un link pubblico. Traccia visualizzazioni e clic in Analisi Condivisione."
        }
      ],
      account: [
        {
          q: "Posso annullare in qualsiasi momento?",
          a: "Sì. Annulla istantaneamente da Impostazioni → Fatturazione. Nessuna domanda, nessuna commissione nascosta, nessun attrito."
        },
        {
          q: "Perdo l'accesso dopo l'annullamento?",
          a: "Sì. L'accesso termina immediatamente dopo l'annullamento. Scarica prima le tue creazioni dalla Galleria."
        },
        {
          q: "Come elimino il mio account?",
          a: "Contatta il supporto a contact@mockuppro.org. Processeremo la tua richiesta entro 48 ore."
        },
        {
          q: "I miei dati sono al sicuro?",
          a: "Sì. Tutti i dati sono crittografati. Non vendiamo né condividiamo le tue informazioni. Le immagini sono memorizzate in modo sicuro."
        }
      ]
    }
  };

  return faqData[language] || faqData.en;
};
